import Api from '../../../helpers/Api';

export const SET_DATA_MOST_READ = 'SET_DATA_MOST_READ';
const setDataNewsMostRead = (dataNewsMostRead = '') => ({
    type: SET_DATA_MOST_READ,
    dataNewsMostRead,
});

export const INSERT_NEWS_VIEW = 'INSERT_NEWS_VIEW';

export const insertNewsView = (newsView) => ({
    type: INSERT_NEWS_VIEW,
    newsView,
});

export const RESET_NEWS_VIEWS = 'RESET_NEWS_VIEWS';

export const resetNewsViews = () => ({
    type: RESET_NEWS_VIEWS,
});


export const fetchDataNewsMostReadIfNeeded = () => (dispatch, getState) => {
    const dataNewsMostRead = getState().news.dataNewsMostRead;

    if (dataNewsMostRead.length === 0) {
        const limitNews = 4;

        return Api.progressGet(dispatch, `/api/v1/news/getNewsMostRead/${limitNews}`).then((json) => {
            if (json.status === 'success') {
                return dispatch(setDataNewsMostRead(json.data));
            }

            throw `error from server: ${json.message}`;
        })
            .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('There has been a problem with your fetch operation: ', error);
            });
    }

    return Promise.resolve(1);
}

const _sendViews = (dispatch, getState) => {
    const newsViews = getState().news.newsViews;
    const token = getState().profile.jwt;
    const sessionHash = getState().profile.sessionHash;

    // NOTE: check the load on the server (also on mysql) when using the authenticated route to get the userId.
    // As this means that every view log request results in the decryption of the token and a subsequent database query, this might be heavy
    // If it is too heavy we can omit security and send the userId with the request and skip server side authentication...
    // Good thing is, that there are pretty few users that are constantly logged in :D

    if (newsViews.length < 1) {
        // abort. Not sure when exactly this happens but the array comes empty sometimes when navigating through the page
        return false;
    }

    let query;

    if (token) {
        // logged in user
        query = 'api/v1/tracking/newsViewsHitAuth';
    } else {
        // not logged in user
        query = 'api/v1/tracking/newsViewsHit';
    }

    const data = {
        sendTime: new Date(),
        sessionHash,
        newsViews,
    };

    return Api.progressPost(dispatch, query, data, token)
        .then((json) => {
            if (json.status !== 'success') {
                throw `error from server: ${json.message}`;
            } else {
                return dispatch(resetNewsViews());
            }
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('Error sending views, not resetting newsViews ', error);
        });
};
let timerHandle;

export const countNewsView = (newsView) => (dispatch, getState) => {
    // we insert the news into newsViews and send them to the server after 2 seconds,
    // if there is another call before the timer end, the timer will be canceled and a new one started.
    // we do this to reduce the load on the server.

    // update newsViews Array
    dispatch(insertNewsView(newsView));

    // cancel previous timeouts
    clearTimeout(timerHandle);

    // start new timeout and call sendViews
    timerHandle = setTimeout(() => _sendViews(dispatch, getState), 2000);
};
